module.exports = __webpack_public_path__ + "static/img/ic_subway@2x.2fa023e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_subway@2x.png
// module id = pBGs
// module chunks = 1